namespace GeniuzPOS.Product {
    export class CsConceptColumns {
        static columnsKey = 'Product.CsConcept';
    }
}
